import type { OddsType, Locale } from '../types';

const DEFAULT_ODDS_TYPE: OddsType = 'European';

/* ВАЖНО!
 *
 * Это НЕ СПИСОК СУЩЕСТВУЮЩИХ ЛОКАЛЕЙ.
 * 
 * Это просто список локалей, для который заведены словари.
 * 
 * ОНИ НЕ СООТВЕТСТВУЮТ реальным локалям, используемым на сайтах.
 * В локали может прийти ЧТО УГОДНО.
 * 
 * Это список для ТЕСТОВ.
 * МИНИМАЛЬНОЕ известное покрытие значений.
 */
const BASICALLY_SUPPORTED_LOCALES: Locale[] = [
    'ru', // русский
    'en', // английский
    'ar', // арабский
    'az', // азербайджанский
    'be', // белорусский
    'es', // испанский
    'fr', // французский
    'hi', // хинди
    'ja', // японский
    'kk', // казахский
    'ko', // корейский
    'pt', // португальский
    'sr', // сербский
    'uz', // узбекский
    'zh' // китайский
];

export {
    DEFAULT_ODDS_TYPE,
    BASICALLY_SUPPORTED_LOCALES,
}
